'use client';
import React, { useEffect, useState } from 'react';
import { llmChat, ReferenceItem } from '@/app/services/llm';
import { marked } from 'marked';
import { convertAbstractToMarkdownAdvanced } from '@/lib/util';

const ctrl = new AbortController();

const TranslateAbstract = ({
  docId,
  type,
}: {
  docId: string;
  type: 'title' | 'abstract';
}) => {
  const [zhAbstract, setZhAbstract] = useState<ReferenceItem>({
    pub_day: '',
    title: '',
    abstract: '',
    publisher: '',
    publisher_abbr: '',
    pub_year: 0,
    pub_month: 0,
    link: '',
    doi: '',
    authors: [],
    doc_id: '',
    pub_source_str: '',
    pmid: '',
  });

  const onTranslate = async (docId: string) => {
    await llmChat<{ result: ReferenceItem; type: string }>({
      path: `/v2/doc/${encodeURIComponent(docId)}/translate_doc_stream`,
      body: {},
      ctrl,
      onMessage: (message) => {
        const result = message.result;
        if (result.translation && result.translation['zh-cn']) {
          setZhAbstract({
            ...result,
            title: result.translation['zh-cn'].title,
            abstract: result.translation['zh-cn'].abstract,
          });
          return;
        }

        if (result.title) {
          zhAbstract.title += result.title;
        }
        if (result.abstract) {
          zhAbstract.abstract += result.abstract;
        }
        if (message.type === 'all_done') {
          setZhAbstract({
            ...result,
            title: result.translation!['zh-cn'].title,
            abstract: result.translation!['zh-cn'].abstract,
          });
        } else {
          setZhAbstract({ ...zhAbstract });
        }
      },
      onOpen: () => {},
      onClose: async () => {
        // await updateUserInfo();
      },
      onError: () => {},
    });
  };

  useEffect(() => {
    onTranslate(docId);
  }, []);

  if (type === 'title') {
    return <h1 className="text-2xl font-semibold">{zhAbstract.title}</h1>;
  }

  return (
    <div className="flex-1">
      <div className="pb-4">
        <strong>摘要</strong>
      </div>
      <div
        className="space-y-4 markdown-body text-base"
        dangerouslySetInnerHTML={{
          __html: marked(
            convertAbstractToMarkdownAdvanced(zhAbstract.abstract ?? ''),
          ) as string,
        }}
      ></div>
    </div>
  );
};

export default TranslateAbstract;
